import type { VideoItem } from './types';

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '都市夜话：城市光影中的温暖故事',
    description: '穿梭于繁华都市的夜晚，镜头捕捉那些不为人知的温暖瞬间。从街头艺人到深夜便利店，每一帧都是生活的真实写照。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=warm%20city%20night%20scene%20with%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20street%20photography%20style%2C%20soft%20bokeh%20lights%2C%20warm%20amber%20and%20soft%20pink%20tones%2C%20atmospheric%20mood%2C%20clean%20composition%20with%20shallow%20depth%20of%20field%2C%20editorial%20photography&width=640&height=360&seq=mitao-thumb-01&orientation=landscape',
    duration: '32:15',
    views: '128.5万',
    date: '2026-08-08',
    featured: true,
    trending: true,
  },
  {
    id: 'v002',
    title: '探秘深蓝：海洋深处的奇幻世界',
    description: '跟随水下摄影师的镜头，潜入蔚蓝深海，探索珊瑚礁的绚丽色彩与海洋生物的奇妙生态，感受大自然的神奇魅力。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=vibrant%20underwater%20coral%20reef%20scene%20with%20colorful%20tropical%20fish%2C%20crystal%20clear%20blue%20water%2C%20sunlight%20rays%20piercing%20through%20ocean%20surface%2C%20rich%20marine%20life%2C%20warm%20and%20vivid%20colors%2C%20cinematic%20wide%20angle%2C%20clean%20aesthetic&width=640&height=360&seq=mitao-thumb-02&orientation=landscape',
    duration: '45:20',
    views: '96.8万',
    date: '2026-08-07',
    featured: true,
    trending: true,
  },
  {
    id: 'v003',
    title: '食在四方：街头美食寻味之旅',
    description: '走遍大街小巷，探寻最地道的街头美食。从清晨的豆浆油条到深夜的烧烤摊，用味蕾感受城市的烟火气息。',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20street%20food%20market%20at%20night%20with%20steaming%20hot%20dishes%2C%20colorful%20food%20stalls%2C%20warm%20ambient%20lighting%2C%20bustling%20atmosphere%2C%20steam%20rising%20from%20freshly%20cooked%20noodles%2C%20rich%20warm%20tones%2C%20cinematic%20food%20photography%2C%20shallow%20depth%20of%20field&width=640&height=360&seq=mitao-thumb-03&orientation=landscape',
    duration: '28:45',
    views: '215.3万',
    date: '2026-08-06',
    featured: true,
    trending: true,
  },
  {
    id: 'v004',
    title: '星际迷途：科幻巨制年度大片',
    description: '当人类文明面临外星威胁，一群勇敢的宇航员踏上了拯救地球的星际征程。震撼的视觉特效与扣人心弦的剧情。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20scene%20with%20astronaut%20floating%20near%20a%20massive%20spaceship%2C%20distant%20galaxy%20and%20nebula%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20deep%20blues%20with%20warm%20orange%20accents%2C%20clean%20composition&width=640&height=360&seq=mitao-thumb-04&orientation=landscape',
    duration: '2:18:42',
    views: '356.7万',
    date: '2026-08-05',
    featured: true,
    trending: false,
  },
  {
    id: 'v005',
    title: '清风明月：古风仙侠爱情故事',
    description: '讲述一段跨越三界的仙侠爱恋，唯美的画面与动人的音乐交织成一曲凄美的东方幻想诗篇。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=romantic%20ancient%20Chinese%20fantasy%20scene%20with%20flowing%20silk%20robes%20in%20peach%20blossom%20garden%2C%20soft%20ethereal%20mist%2C%20warm%20golden%20sunlight%20filtering%20through%20petals%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20elegant%20and%20poetic%20mood&width=640&height=360&seq=mitao-thumb-05&orientation=landscape',
    duration: '45:18',
    views: '189.2万',
    date: '2026-08-04',
    featured: false,
    trending: true,
  },
  {
    id: 'v006',
    title: '机甲战士：未来纪元热血激战',
    description: '在未来世界，人类驾驶巨型机甲与入侵者展开殊死搏斗。炸裂的战斗场面和炫目的机甲设计令人热血沸腾。',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=futuristic%20mecha%20robot%20battle%20scene%20in%20a%20destroyed%20city%2C%20dynamic%20action%20pose%2C%20warm%20golden%20sunset%20lighting%20with%20sparks%20and%20explosions%2C%20anime%20art%20style%2C%20dramatic%20composition%2C%20vivid%20colors%2C%20cinematic%20wide%20shot&width=640&height=360&seq=mitao-thumb-06&orientation=landscape',
    duration: '24:30',
    views: '156.8万',
    date: '2026-08-03',
    featured: false,
    trending: true,
  },
  {
    id: 'v007',
    title: '欢乐集结号：爆笑综艺精选合集',
    description: '汇集最搞笑的综艺名场面，从即兴表演到游戏挑战，让你从头笑到尾，释放所有压力。',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=bright%20colorful%20variety%20show%20stage%20with%20confetti%20and%20cheerful%20atmosphere%2C%20warm%20studio%20lighting%2C%20vibrant%20decorations%2C%20energetic%20and%20fun%20vibe%2C%20cinematic%20wide%20shot%2C%20clean%20and%20professional%20composition&width=640&height=360&seq=mitao-thumb-07&orientation=landscape',
    duration: '1:05:30',
    views: '278.4万',
    date: '2026-08-02',
    featured: true,
    trending: true,
  },
  {
    id: 'v008',
    title: '极地奇迹：北极圈生命探索',
    description: '深入北极圈，记录极端环境下生命的顽强与美丽。从北极熊到极光，每一帧都是大自然的鬼斧神工。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=majestic%20aurora%20borealis%20over%20snowy%20arctic%20landscape%20with%20polar%20bear%20in%20foreground%2C%20stunning%20natural%20phenomenon%2C%20cool%20blue%20and%20green%20lights%20dancing%20in%20night%20sky%2C%20pristine%20wilderness%2C%20cinematic%20documentary%20style%2C%20breathtaking%20composition&width=640&height=360&seq=mitao-thumb-08&orientation=landscape',
    duration: '52:10',
    views: '87.3万',
    date: '2026-08-01',
    featured: false,
    trending: false,
  },
  {
    id: 'v009',
    title: '青春不散场：校园成长励志剧',
    description: '一群性格迥异的高中生在高考前夕经历友情、爱情与梦想的碰撞，用青春书写最动人的篇章。',
    category: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=warm%20sunlit%20school%20campus%20scene%20with%20cherry%20blossom%20trees%2C%20students%20walking%20and%20laughing%20together%2C%20golden%20afternoon%20light%2C%20nostalgic%20youthful%20atmosphere%2C%20soft%20and%20dreamy%20photography%2C%20clean%20composition%2C%20warm%20peach%20tones&width=640&height=360&seq=mitao-thumb-09&orientation=landscape',
    duration: '42:30',
    views: '145.6万',
    date: '2026-07-31',
    featured: false,
    trending: false,
  },
  {
    id: 'v010',
    title: '功夫传奇：中华武术精髓展示',
    description: '从少林到武当，从太极拳到咏春拳，深入探访中国武术圣地，感受千年武术文化的博大精深。',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=traditional%20Chinese%20martial%20arts%20master%20practicing%20in%20ancient%20temple%20courtyard%20at%20sunrise%2C%20flowing%20movement%2C%20misty%20morning%20atmosphere%2C%20warm%20golden%20light%2C%20cinematic%20composition%2C%20elegant%20and%20powerful%20pose%2C%20cultural%20aesthetic&width=640&height=360&seq=mitao-thumb-10&orientation=landscape',
    duration: '1:38:20',
    views: '203.1万',
    date: '2026-07-30',
    featured: true,
    trending: false,
  },
  {
    id: 'v011',
    title: '萌宠日记：可爱动物趣味集锦',
    description: '记录各种可爱宠物和野生动物的趣味日常，从调皮的猫咪到忠实的狗狗，每一个瞬间都萌化你的心。',
    category: 'short',
    thumbnail: 'https://readdy.ai/api/search-image?query=adorable%20fluffy%20kitten%20and%20puppy%20playing%20together%20in%20a%20cozy%20sunlit%20room%2C%20soft%20natural%20light%2C%20warm%20and%20cheerful%20mood%2C%20shallow%20depth%20of%20field%2C%20clean%20background%2C%20cute%20and%20heartwarming%20photography&width=640&height=360&seq=mitao-thumb-11&orientation=landscape',
    duration: '8:45',
    views: '398.7万',
    date: '2026-07-29',
    featured: false,
    trending: true,
  },
  {
    id: 'v012',
    title: '科技前沿：人工智能改变生活',
    description: '探索最新AI技术如何重塑我们的日常生活，从智能家居到自动驾驶，感受科技带来的无限可能。',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=futuristic%20smart%20home%20interior%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20soft%20neutral%20tones%20with%20subtle%20warm%20accents%2C%20modern%20technology%20aesthetic%2C%20cinematic%20wide%20shot%2C%20professional%20composition&width=640&height=360&seq=mitao-thumb-12&orientation=landscape',
    duration: '38:15',
    views: '112.4万',
    date: '2026-07-28',
    featured: false,
    trending: false,
  },
];